import type { FaireProductEntity } from "../../entity_types/product";

export const p_kb9z8bjhyz: FaireProductEntity = {
  token: "p_kb9z8bjhyz",
  type: "product",
  name: "Squishy Tomato Ball Kids Toy",
  brandToken: "b_275xefbjkx",
  brandName: "Toyarina",
  imageUrl:
    "https://cdn.faire.com/fastly/6d421f277b29dce3d39d21fe3061791efd68b3a4b2dd1acfa82fe1dd61bf5001.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/273547e7a21ac731a63470cea42008186812374af70c0b8502fc348b46cc5535.jpeg",
    "https://cdn.faire.com/fastly/8a91b1e2ada3aedb4dd2442717594cfde7dd64ac849af668d59f7448c7e66079.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "- Squishy Sensation: Made from soft and pliable materials, this tomato-shaped ball offers a satisfying squishy sensation when squeezed, providing tactile stimulation and stress relief for little hands.\n\n- Vibrant Design: Styled to resemble a ripe and juicy tomato, this squishy ball features bright colours and realistic details that capture the imagination and enhance playtime fun.\n\n- Versatile Play: Whether squeezed, tossed, or rolled, this squishy tomato ball encourages active play and imaginative exploration. Kids can bounce it, catch it, or incorporate it into their pretend cooking adventures.\n\n- Safe and Durable: Crafted from non-toxic materials, this squishy toy is safe for kids to play with and durable enough to withstand rough handling and regular use, ensuring long-lasting enjoyment.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:44.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
